import { useSnackbar } from "notistack";
import { web_url } from "../../config/config";
import { Icon } from "@iconify/react/dist/iconify.js";

const SharePostPopup = ({ postData, type = "" }) => {
  const { enqueueSnackbar } = useSnackbar();

  const prepareShareContent = (postData) => {
    let shareContent = `*TalentSource*\n*Connecting Top Talent With Top Jobs.*\n\n`;
    if (postData?.description) {
      shareContent += `${postData.description}\n\n`;
    }
    shareContent = `${web_url}?${type}=${postData._id}`;
    return shareContent;
  };

  const shareToWhatsApp = () => {
    const shareText = prepareShareContent(postData);
    const url = `https://wa.me/?text=${encodeURIComponent(shareText)}`;
    window.open(url, "_blank");
  };

  const shareToFacebook = () => {
    const url = encodeURIComponent(`${web_url}?${type}=${postData._id}`);
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    window.open(facebookShareUrl, "_blank");
  };

  const shareToTwitter = () => {
    const shareText = prepareShareContent(postData);
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      shareText
    )}`;
    window.open(url, "_blank");
  };

  const shareToLinkedIn = () => {
    // let shareContent = `TalentSource\nConnecting Top Talent With Top Jobs.\n\n`;
    let shareContent = ``;

    shareContent += `${postData?.description ? `` : ""}${web_url}?${type}=${
      postData._id
    }`;
    const url = `https://www.linkedin.com/sharing/share-offsite/?text=${encodeURIComponent(
      shareContent
    )}`;
    window.open(url, "_blank");
  };

  const shareToEmail = () => {
    const subject = "";
    const body = prepareShareContent(postData);
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(gmailLink, "_blank");
  };

  const shareToOutlook = () => {
    const subject = "";
    const body = prepareShareContent(postData);
    const outlookLink = `https://outlook.live.com/owa/?path=/mail/action/compose&subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(outlookLink, "_blank");
  };

  const copyToClipboard = async () => {
    try {
      // const shareText = prepareShareContent(postData);
      const shareText = `${web_url}?${type}=${postData._id}`;
      await navigator.clipboard.writeText(shareText);
      enqueueSnackbar("Link copied!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to copy please try again", { variant: "error" });
    }
  };

  const shareNative = async () => {
    if (!navigator.share) {
      enqueueSnackbar("Native share is not supported on this device.", {
        variant: "warning",
      });
      return;
    }

    try {
      const shareText = prepareShareContent(postData);
      await navigator.share({
        title: "TalentSource",
        text: shareText,
        url: `${web_url}?${type}=${postData._id}`,
      });
    } catch (error) {
      console.error("Native share failed:", error);
    }
  };

  return (
    <div className="">
      {/* Copy Link Box */}
      <div
        className="tw-flex tw-items-center tw-justify-between tw-p-3 tw-rounded-lg 
                       tw-bg-gray-100 tw-border tw-border-gray-200 tw-cursor-pointer
                       hover:tw-bg-gray-200 tw-transition-all tw-duration-150 tw-mb-4"
        onClick={copyToClipboard}
      >
        <p className="tw-truncate tw-flex-1 tw-mr-3 tw-text-sm tw-text-gray-700 mb-0">
          {`${web_url}?${type}=${postData._id}`}
        </p>

        <Icon
          icon="material-symbols-light:content-copy-rounded"
          className="tw-text-gray-600"
          width="22"
          height="22"
        />
      </div>

      {/* Section Title */}
      <h6 className="tw-text-base tw-font-semibold tw-mb-3">Share To</h6>

      {/* Share Buttons Grid */}
      <div className="row gy-3 gx-2">
        {[
          {
            icon: "fab fa-whatsapp",
            title: "WhatsApp",
            onClick: shareToWhatsApp,
            color: "#25D366",
          },
          {
            icon: "fab fa-facebook-f",
            title: "Facebook",
            onClick: shareToFacebook,
            color: "#1877F2",
          },
          {
            icon: "fab fa-x-twitter",
            title: "X",
            onClick: shareToTwitter,
            color: "#000000",
          },
          {
            icon: "fab fa-linkedin-in",
            title: "LinkedIn",
            onClick: shareToLinkedIn,
            color: "#0077B5",
          },
          {
            icon: "fas fa-envelope",
            title: "Gmail",
            onClick: shareToEmail,
            color: "#EA4335",
          },
          // {
          //   icon: "fas fa-envelope-open-text",
          //   title: "Outlook",
          //   onClick: shareToOutlook,
          //   color: "#0072C6",
          // },
          {
            icon: "fas fa-share-alt",
            title: "Share More",
            onClick: shareNative,
            color: "#666666",
            nativeOnly: true,
          },
        ].map((item, index) => (
          <div
            className="col-6 d-flex align-items-center cursor-pointer tw-py-1"
            onClick={item.onClick}
            key={index}
          >
            <button
              type="button"
              className="share-icon-btn tw-flex tw-items-center tw-justify-center 
                             tw-w-10 tw-h-10 tw-rounded-full tw-text-white tw-text-lg 
                             tw-shadow-sm hover:tw-scale-105 tw-transition-all"
              style={{ backgroundColor: item.color }}
              title={item.title}
            >
              <i className={item.icon}></i>
            </button>

            <span className="ms-3 tw-text-sm tw-font-medium tw-text-gray-800">
              {item.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SharePostPopup;
